<template>
<form
  id="app"
  @submit="checkForm"
  action=""
  method="post"
  class="h-100"
  :class="[loading ? 'loading' : '']"
  data-gtm-form-interact-id="0"
>

    <h2 class="step-title">{{ this.__('giftcard.delivery-informations') }}</h2>

    <div v-if="Object.keys(errors).length">
        <div class="alert alert-danger" role="alert" v-for="error in errors">
            <strong>{{ error }}</strong>
        </div>
    </div>

    <div class="giftcard-form credentials-box my-4">
        <span>{{ this.__('giftcard.recipient.intro') }}</span>

        <input
            type="name"
            v-model="recipient_name"
            :class="'form-control ' + [errors['email'] ? 'is-invalid' : '']"
            autocomplete="name"
            :placeholder="this.__('giftcard.recipient.name')"
            required autofocus>
        
        <input
            type="email"
            v-model="recipient_email"
            :class="'form-control ' + [errors['email'] ? 'is-invalid' : '']"
            autocomplete="email"
            :placeholder="this.__('giftcard.recipient.email')"
            required>
            
        <span>{{ this.__('giftcard.sender.intro') }}</span>

        <input
            type="name"
            v-model="sender_name"
            :class="'form-control ' + [errors['email'] ? 'is-invalid' : '']"
            autocomplete="name"
            :placeholder="this.__('giftcard.sender.name')"
            required>
        
        <input
            type="email"
            v-model="sender_email"
            :class="'form-control ' + [errors['email'] ? 'is-invalid' : '']"
            autocomplete="email"
            :placeholder="this.__('giftcard.sender.email')"
            required>
            
        <hr class="my-3">
        
        <span class="opacity-50">{{ this.__('giftcard.custom-message') }}<span class="option">({{ this.__('giftcard.optional') }})</span></span>
        <textarea 
            v-model="message"
            class="form-control mh-100 opacity-50"
            :placeholder="this.__('giftcard.placeholder')"
            rows="5"></textarea>
                        
    </div>

    <button type="submit" class="d-flex justify-content-center align-items-center mt-4 btn btn-authent btn-lg btn-block cg-submit">
        {{ this.__('trads.Continue') }}
        <img class="next-arrow" src="/img/style/next-arrow.svg">
    </button>

</form>

</template>

<script>
import store from './store.js';

export default {
    store,
    props: [],
    data () {
        return {
            loading: null,
            errors: {},
            recipient_name: store.state.recipient_name,
            recipient_email: store.state.recipient_email,
            sender_name: store.state.sender_name,
            sender_email: store.state.sender_email,
            message: store.state.message,
        }
    },
    beforeMount () {
        // this.selectedPlan = this.selected ? this.selected : this.$parent.defaultPlan;
    },
    methods: {
        checkForm: function(e) {
            e.preventDefault();

            this.loading = true;
            this.errors = {};

            return this.$parent.nextStep();
        }
    },
    watch: {
        recipient_name: function(newValue) {
            store.commit('setRecipientName', newValue)
        },
        recipient_email: function(newValue) {
            store.commit('setRecipientEmail', newValue)
        },
        sender_name: function(newValue) {
            store.commit('setSenderName', newValue)
        },
        sender_email: function(newValue) {
            store.commit('setSenderEmail', newValue)
        },
        message: function(newValue) {
            store.commit('setMessage', newValue)
        },
    }
}
</script>

<style></style>